// useChatState.js
import { ref, watch, computed } from 'vue';

const currentUser = ref(null);
const messages = ref([]);
const newMessage = ref('');

const selectedProject = ref(null);

const aiOptions = ref([
  { label: 'AI A', value: { aiStr: 'claude' } },
  { label: 'AI G', value: { aiStr: 'gemini' } },
  { label: 'AI O', value: { aiStr: 'chatgpt' } },
]);
const selectedAI = ref(aiOptions[0]);

const projectOptions = ref([
  { label: 'SNK-SIT-03', value: { prjId: 'SNK-SIT-03' } },
  { label: '202108_094', value: { prjId: 'D2S_202108_094' } },
  { label: '202105_056', value: { prjId: '202105_056' } },
]);

watch(selectedAI, (newVal) => {
  console.log('Selected AI ID:', newVal?.value?.aiStr);
});

watch(selectedProject, (newVal) => {
  console.log('Selected Project ID:', newVal?.value?.prjId);
});

export function useChatState() {
  return {
    currentUser,
    messages,
    newMessage,
    selectedAI,
    aiOptions,
    selectedProject,
    projectOptions,
  };
}
